import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createReturnedReportSlice = (set, get) => ({
    returnedReports: {
        loading: false,
        returnedSettlementReports: [],
        returnedPaidToUserReports: [],
        returnedPaidSettlementToUserReports: [],
    },
    getWaitingForSettlementReturnedReports: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ returnedReports: { ...state.returnedReports, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/business/Waiting-For-Settlement-Return-To-User`,
                headers: { token },
            });
            set(state => ({ returnedReports: { ...state.returnedReports, loading: false, returnedSettlementReports: resp.data.Items } }));
        } catch (error) {
            set(state => ({ returnedReports: { ...state.returnedReports, loading: false } }));
        }
    },
    getPaidToUserReturnedReports: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ returnedReports: { ...state.returnedReports, loading: true, returnedPaidToUserReports: [] } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/business/Paid-Return-To-User/${param.fromDate}/${param.toDate}`,
                headers: { token },
            });
            set(state => ({ returnedReports: { ...state.returnedReports, loading: false, returnedPaidToUserReports: resp.data.Items } }));
        } catch (error) {
            set(state => ({ returnedReports: { ...state.returnedReports, loading: false } }));
        }
    },
    postPaidSettlementReturnedReports: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ returnedReports: { ...state.returnedReports, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: `/v1/business/Paid-Settlement-Return-To-User`,
                data: params,
                headers: { token },
            });
            set(state => ({ returnedReports: { ...state.returnedReports, loading: false, returnedPaidSettlementToUserReports: resp.data.Items } }));
        } catch (error) {
            set(state => ({ returnedReports: { ...state.returnedReports, loading: false } }));
        }
    }
});
